import apiConfig from '@/services/apiConfig';

const urlErpWebApp = apiConfig.getUrlErpWebApp();
const token = apiConfig.getToken();
const tokenLogin = apiConfig.getTokenLogin();

const abrirHistoricoSaldoServicos = (id) => {
  let fullUrl = `${urlErpWebApp}/relatorioSaldoServicos/${id}?auth=${token}`;
  let options = `width=${screen.availWidth}, height=${screen.availHeight}`;

  window.open(fullUrl, 'Saldo de Serviços', options);
};

const criarProntuario = (idComanda) => {
  let fullUrl = `${urlErpWebApp}/prontuario/${idComanda}?auth=${tokenLogin}`;
  
  window.open(fullUrl, 'Prontuário');
}
const erpWebApiService = {
  abrirHistoricoSaldoServicos,
  criarProntuario
};

export default erpWebApiService;
